export default {
  container: (isAtHomePage: boolean) => ({
    position: 'fixed',
    zIndex: 4,
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: isAtHomePage ? 'transparent' : 'white',
    fontFamily: 'Arial'
  }),
  child: {
    maxWidth: 1200,
    padding: '16px 0px'
  },
  message: (color: string) => ({
    fontSize: 12,
    marginLeft: 16,
    color
  }),
  anchor: (color: string) => ({
    color
  }),
  button: (color: string) => ({
    background: 'transparent',
    marginRight: 16,
    border: `1px solid ${color}`,
    width: '130px',
    height: '35px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color,
    cursor: 'pointer'
  })
}
